import { Countries } from '../../data/Countries';
import regions from '../../data/regions.json';

// Filter countries dynamically based on search input
export const findCountry = (query: string) => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return Promise.resolve([]);

  const result = Countries.filter((c) =>
    c.name.toLowerCase().includes(trimmed)
  );

  return Promise.resolve(result);
};

export const findStateInCountry = (query: string, selectedCountry: string) => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return Promise.resolve([]);

  const country = regions.find(
    (c) =>
      c.name.toLowerCase() === selectedCountry.toLowerCase() ||
      c.code2.toLowerCase() === selectedCountry.toLowerCase()
  );

  if (!country) return Promise.resolve([]);

  const result = country.states?.filter((s) =>
    s.name.toLowerCase().includes(trimmed)
  );

  return Promise.resolve(result);
};
